import React from 'react';

const Modal = ({ isOpen, onClose, children, hideClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black opacity-10"></div>
      <div className="relative bg-white rounded-lg p-6 w-full max-w-md mx-4">
        {!hideClose && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;